<div class="container">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
          <div class="popup-title mr-auto" translate>
            <ng-container *ngIf="true;else load_else " translate>
              lblAddAccount
            </ng-container>
            <ng-template #load_else translate>
              lblEditAccount
             </ng-template>
          </div>
          <div class="float-right">
            <a class="close mr-2" (click)="OnClose()" translate>
              <span class="" aria-hidden="true">&times;</span>
              </a>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between bg-grey">
          <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li *ngFor="let tab of tabs | slice:0:noOfTabLimit; let i=index" class="nav-item" >
              <a translate class="nav-link" (click)="tabSelected(tab.id)"  [ngClass]="{'active': selectedtab===tab.id}">{{tab.label}}</a>
            </li>
          </ul>
         
        </div>
       
        <form [formGroup]="accountForm" (ngSubmit)="AddEditAccount()" >
            <div class=" scrollbar longtab">
                <div class=" ">
                    <div class="cst-acc-card mb20">
        
                        <div class="row">
                            <div class="col-3 mt-3">
                                <label for="template-accountName" translate>lblAccountName </label>
                                <strong class="mlt6 required"> * </strong>
                                <div class='lbl-info'>
                                    <input type="text" id="template-accountName" name="accountName" formControlName="accountName"
                                        class="form-control" placeholder="{{ 'lblEnterAccountName' | translate }}"
                                        maxlength="100"
                                        [ngClass]="{'is-invalid':(cpf.accountName.invalid  && cpf.accountName.touched) || (cpf.accountName.invalid  && isFormValid)}"
                                        >
                                    <div *ngIf="(cpf.accountName.invalid  && (cpf.accountName.dirty || cpf.accountName.touched)) || (cpf.accountName.invalid  && isFormValid)"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.accountName.errors.required"><span
                                                translate>lblRequiredAccountName</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-3 mt-3" *ngIf="false">
                                <label for="template-accountNo" translate>lblCustomerNumber</label>
                                <input type="text" id="template-accountNo" name="accountNo" formControlName="accountNo"
                                    class="form-control" disabled />
                            </div>
                            <div class="col-3 mt-3">
                                <label for="template-registrationNumber" translate>lblRegNumber</label>
                                <strong class="mlt6 required"> * </strong>
                                <div class='lbl-info'>
                                    <input type="text" id="template-registrationNumber" name="registrationNumber" formControlName="registrationNumber" 
                                    class="form-control" placeholder="{{ 'lblEnterRegistrationNumber' | translate }}" maxlength="20"
                                    [ngClass]="{'is-invalid':(cpf.registrationNumber.invalid  && cpf.registrationNumber.touched) || (cpf.registrationNumber.invalid  && isFormValid)}">
                                    <div *ngIf="(cpf.registrationNumber.invalid  && (cpf.registrationNumber.dirty || cpf.registrationNumber.touched)) || (cpf.registrationNumber.invalid  && isFormValid)"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.registrationNumber.errors.required"><span
                                                translate>lblRequiredRegistrationNumber</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 mt-3">
                                <label for="txtregistrationDate" translate>lblRegistrationDate</label>
                                <strong class="mlt6 required"> * </strong>
                                <div class="lbl-info cal-date">
                                    <input class="form-control datePicker width100force" appAfDatepicker [(ngModel)]="registrationDate" autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false" id="txtregistrationDate" formControlName="registrationDate" name="registrationDate" type="text"
                                        value="" [endDate]="endDate"
                                        [ngClass]="{'is-invalid':(cpf.registrationDate.invalid  && cpf.registrationDate.touched) || (cpf.registrationDate.invalid  && isFormValid)}">
                                        <div *ngIf="(cpf.registrationDate.invalid  && (cpf.registrationDate.dirty || cpf.registrationDate.touched)) || (cpf.registrationDate.invalid  && isFormValid)"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.registrationDate.errors.required"><span
                                                translate>lblRequiredRegistrationDate</span>
                                        </div>
                                    </div>    
                                    <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                                </div>
                            </div>
                            <div class="col-3 mt-3">
                                <label for="template-salutation" translate>lblSalutation</label>
                                <strong class="mlt6 required"> * </strong>
                                <div class='lbl-info'>
                                    <ng-select formControlName="salutation"
                                        placeholder="{{ 'lblSelectSalutation' | translate }}" [(ngModel)]="salutationName">
                                        <ng-template ng-header-tmp>
                                            <span class="mbold w-66px">Code</span>
                                            <span class="mbold" translate>lblSalutation</span>
                                        </ng-template>
        
                                        <ng-option *ngFor="let item of addressSalutationList" [value]="item.code">
                                            <span class="w-66px">{{item.code}}</span>
                                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                            <span>{{item.description}}</span>
                                        </ng-option>
                                    </ng-select>
                                    <div *ngIf="(cpf.salutation.invalid  && (cpf.salutation.dirty || cpf.salutation.touched)) || (cpf.salutation.invalid  && isFormValid)"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.salutation.errors.required"><span
                                                translate>lblRequiredSalutation</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cst-acc-card mb20">
                        <div class="row">
                            <div class="col-3">
                                <label for="template-address1" translate>lblAddress1</label><strong *ngIf="isAddress1Required" class="mlt6 required"> *
                                </strong>
                                <div class='lbl-info'>
                                    <input type="text" id="template-address1" name="address1" formControlName="address1"
                                        class="form-control" placeholder="{{ 'lblEnterAddressLine 1' | translate }}" required
                                        maxlength="100"
                                        [ngClass]="{'is-invalid':(cpf.address1.invalid  && cpf.address1.touched) || (cpf.address1.invalid  && isFormValid)}">
                                    <div *ngIf="(isAddress1Required && (cpf.address1.invalid  && (cpf.address1.dirty || cpf.address1.touched)) || (cpf.address1.invalid  && isFormValid))"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.address1.errors.required"><span translate>lblAddressLine1Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <label for="template-address2" translate>lblAddress2</label>
                                <div class='lbl-info'>
                                    <input type="text" id="template-address2" name="address2" formControlName="address2"
                                        class="form-control" placeholder="{{ 'lblEnterAddressLine 2' | translate }}"
                                        maxlength="100">
                                </div>
                            </div>
                            <div class="col-3">
                                <label for="template-postcode" translate>lblPostCode<strong *ngIf="postcodeRequired"
                                        class="mlt6 required"> *</strong> </label>
                                <div class='lbl-info'>
                                    <ng-select formControlName="postcode" placeholder="{{ 'lblSelectPostCode' | translate }}"
                                        [virtualScroll]="true" [(ngModel)]="postcodeName" (change)="onPostCodeSelected($event)"
                                        [ngClass]="{'ng-select-is-invalid':(cpf.postcode.invalid  && cpf.postcode.touched) || (cpf.postcode.invalid  && isFormValid)}">
                                        <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                                            {{item.code}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="(postcodeRequired && (cpf.postcode.invalid && (cpf.postcode.dirty || cpf.postcode.touched)) || (cpf.postcode.invalid && isFormValid))"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.postcode.errors.required"><span translate>lblRequiredPostCode</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <label for="template-city" translate>lblCity<strong *ngIf="cityRequired"
                                        class="mlt6 required"> *</strong> </label>
                                <div class='lbl-info'>
                                    <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}"
                                        [(ngModel)]="cityName" (change)="onCitySelected($event)"
                                        [ngClass]="{'ng-select-is-invalid':(cpf.city.invalid  && cpf.city.touched) || (cpf.city.invalid  && isFormValid)}">
                                        <ng-option *ngFor="let item of cityList" [value]="item">
                                            {{item}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="(cityRequired && (cpf.city.invalid && (cpf.city.dirty || cpf.city.touched)) || (cpf.city.invalid && isFormValid))"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.city.errors.required"><span translate>lblRequiredCity</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         
                        </div>
        
                        <div class="row mt-3">
                            <div class="col-3">
                                <label for="template-country" translate>lblCountry<strong *ngIf="countryRequired"
                                        class="mlt6 required"> *</strong> </label>
                                <div class='lbl-info'>
                                    <ng-select formControlName="country" placeholder="{{ 'lblSelectCountry' | translate }}"
                                        [(ngModel)]="countryName" (change)="onselectCountry($event)"
                                        [ngClass]="{'ng-select-is-invalid':(cpf.country.invalid  && cpf.country.touched) || (cpf.country.invalid  && isFormValid)}">
                                        <ng-option *ngFor="let item of countryList" [value]="item.id">
                                            {{item.countryName}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="(countryRequired && (cpf.country.invalid && (cpf.country.dirty || cpf.country.touched)) || (cpf.country.invalid && isFormValid))"
                                        class="help-block text-danger">
                                        <div *ngIf="cpf.country.errors.required"><span translate>lblCountryIsRequired</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <label for="email"><span translate>lblEmail</span><strong *ngIf="isEmailRequired" class="mlt6 required"> *</strong>
                                </label>
                                <div class="lbl-info">
                                    <input formControlName="email" maxlength="50"
                                        [ngClass]="{'is-invalid': (isEmailRequired && (cpf.email.touched || cpf.email.dirty) && cpf.email.errors) || (cpf.email.invalid && isFormValid)}"
                                        class="form-control mb-2" placeholder="{{ 'lblEnterEmail' | translate }}" required>
                                    <div
                                        *ngIf="(isEmailRequired && (cpf.email.touched || cpf.email.dirty) && cpf.email.errors) || (cpf.email.invalid && isFormValid)">
                                        <div *ngIf="cpf.email.errors.required" class="help-block mt-1 text-danger" translate>
                                            lblEmailRequired
                                        </div>
                                        <div *ngIf="cpf.email.errors.pattern" class="help-block mt-1 text-danger" translate>
                                            lblEnterValidEmail
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <label for="mobile"><span translate>lblMobile</span><strong *ngIf="isPhoneRequired" class="mlt6 required"> *</strong>
                                </label>
                                <div class="lbl-info">
                                    <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobile" (change)="CheckMobileNumeber($event)" 
                                    [cssClass]="{'form-control': true, 'is-invalid': (isPhoneRequired && (cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors) || (cpf.mobile.invalid && isFormValid)}"
                                    [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false" (keyup)="onMobileChange()"
                                    [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                                    [customPlaceholder]="'lblEnterMobile' | translate" (countryChange)="onCountryChange($event)"
                                    required></ngx-intl-tel-input>
                                    <div
                                        *ngIf="(isPhoneRequired && (cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors) || (cpf.mobile.invalid && isFormValid)">
                                        <div *ngIf="cpf.mobile.errors.required" class="help-block mt-1 text-danger" translate>
                                            lblMobileRequired
                                        </div>
                                        <div *ngIf="cpf.mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                                            lblEnterValidMobile
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 mt-2">
                                <div class="af-form-group mt-4">
                                    <div class="custom-control custom-switch mt-0">
                                        <input type="checkbox" class="custom-control-input" id="isActive"
                                            formControlName="isActive">
                                        <label class="custom-control-label" for="isActive" translate>lblActive</label>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
            <div class="p-3 bg-light pp-footer-top-brdr">
                <div class="row">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                        <button type="submit" class="btn btn-primary btn-lg " translate>
                            <em class="far fa-save font16 align-top mr-2"></em> lblSave
                        </button>
                        <a (click)="OnClose()" class="btn btn-secondary btn-lg ml-3" translate>
                            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                    </div>
                </div>
            </div>
        </form>
      </div>
    </div>
  </div>
  